import { render, staticRenderFns } from "./listCSG.vue?vue&type=template&id=9f0fd438&scoped=true"
import script from "./listCSG.vue?vue&type=script&lang=js"
export * from "./listCSG.vue?vue&type=script&lang=js"
import style0 from "./listCSG.vue?vue&type=style&index=0&id=9f0fd438&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0fd438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f0fd438')) {
      api.createRecord('9f0fd438', component.options)
    } else {
      api.reload('9f0fd438', component.options)
    }
    module.hot.accept("./listCSG.vue?vue&type=template&id=9f0fd438&scoped=true", function () {
      api.rerender('9f0fd438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/account/listCSG.vue"
export default component.exports